<template>
  <div>
    <div v-bind:class="!record.Active ? 'close': ''">
      <div class="record-head">
        <div class="record-left">
          <span class="hourglass_empty">
            <v-icon class="hourglass_empty"></v-icon>
            <b>Trade Prepare</b>
          </span>
          <span class="text-grey">
            |
            <span class="user-name">{{record.UserDetail.Username}}</span>
            |
            {{openTime}} ({{fromNow}})
            |
            Status:
            <v-chip
              class="ml-2"
              label
              :color="record.Data.Status == 'pending' ? '' : record.Data.Status == 'filled' ? '#79C04D' : '#4dbac0'"
              small
            >
              <span v-if="record.Data.Status == 'pending'">
                <v-icon size="15" style="padding-bottom:2px;padding-right:4px">timelapse</v-icon>
                {{remain}}
              </span>
              <span v-else>
                <span v-if="record.Data.Status == 'canceled' || record.Data.Status == 'expired'">
                  <v-icon size="15" style="padding-bottom:2px;padding-right:4px">cancel</v-icon>
                </span>
                {{record.Data.Status}}
              </span>
            </v-chip>
          </span>
          <div class="record-body">
            <b>{{record.Data.TradeType}}</b>
            |
            <b>{{record.Data.Strategy.name}}</b>
            |
            <b>{{record.Data.Symbol}}</b>
            |
            Zone:
            {{record.Data.Price.toFixed(2)}}
          </div>
          <div class="record-body text-grey mt-1">
            <span class="text-grey">{{record.Data.Note}}</span>
          </div>
        </div>
      </div>
      <div class="record-right">
        <submenu :logId="record._id" :parent="parentType" :storeKey="storeKey"/>
      </div>
    </div>
  </div>
</template>

<script>
//import Avatar from "vue-avatar";
var moment = require("moment-timezone");
import submenu from "./submenu.vue"
export default {
  components: {
    submenu
    //    Avatar
  },
  props: ["record"],
  data() {
    return {
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.Timestamp, this.$store.getters.timezone)
        .fromNow(),
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  methods: {
    replyName(val) {
      this.$emit("reply_to", val);
    },
    updateTiems() {
      var value = this.record.Timestamp;
      this.fromNow = moment.tz(value, this.$store.getters.timezone).fromNow();

      if (this.record.Data.TimeInForce != 9999999999999) {
        let start = moment(); // some random moment in time (in ms)
        let end = moment(this.record.Data.TimeInForce); // some random moment after start (in ms)
        let diff = end.diff(start);

        if (Date.now() > this.record.Data.TiTimeInForceF)
          this.remain = "expired";
        else this.remain = moment.utc(diff).format("HH:mm:ss");
      } else {
        this.remain = "Until Cancel";
      }
    }
  },
  filters: {},
  mounted() {
    // updating record time
    this.updateTiems();
    setInterval(() => {
      this.updateTiems();
    }, 1000);
  },

  computed: {
    openTime() {
      var value = this.record.Timestamp;
      return moment.tz(value, this.$store.getters.timezone).format("HH:mm");
    },

    statusReturned() {
      if (this.record.Status == "close") return "Closed";
      else return "";
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}
</style>
